import TYPES from './types';

const INITIAL_STATE = {
  whitelistedOrganizations: [],
  indexesValues: {},
  bulkValues: {}
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.SET_BULK_VALUES:
      return {
        ...state,
        bulkValues: payload
      };

    case TYPES.GET_INDEXES_VALUES.START:
      const data = payload?.params?.loadMore ? {} : { bulkValues: {}, indexesValues: {} };
      return {
        ...state,
        ...data
      };

    case TYPES.GET_INDEXES_VALUES.SUCCESS:
      return {
        ...state,
        indexesValues: payload?.loadMore
          ? { ...state.indexesValues, ...payload?.data }
          : payload?.data
      };

    case TYPES.GET_INDEX_VISIBILITY.SUCCESS:
      return {
        ...state,
        whitelistedOrganizations: payload.organization_ids
      };

    case TYPES.UPDATE_INDEX_VALUE.START:
      return {
        ...state,
        bulkValues: {
          ...state.bulkValues,
          [payload.params.date]: payload.params.index.map(e => e.value)
        },
        indexesValues: {
          ...state.indexesValues,
          [payload.params.date]: payload.params.index.map(outer => ({
            ...state.indexesValues[payload.params.date]?.find(
              inner => inner.market_index_id === outer.market_index_id
            ),
            market_index_id: outer.market_index_id,
            value_date: payload.params.date,
            value: outer.value
          }))
        }
      };

    case TYPES.DELETE_INDEX_VALUE.START:
      const { [payload.date]: indexesDate, ...restIndexesValues } = state.indexesValues;
      const { [payload.date]: bulkDate, ...restBulkValues } = state.bulkValues;

      return {
        ...state,
        bulkValues: {
          ...restBulkValues
        },
        indexesValues: {
          ...restIndexesValues
        }
      };

    case TYPES.UPDATE_INDEX_VALUE.SUCCESS:
      return {
        ...state
      };
    default:
      return state;
  }
};

export default reducer;
